// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-table[data-v-4dda240a] .laravel-vue-datatable-tbody-tr{-webkit-transition:all .06s ease-out;transition:all .06s ease-out;cursor:pointer}.contact-table[data-v-4dda240a] .laravel-vue-datatable-tbody-tr.tr-focused,.contact-table[data-v-4dda240a] .laravel-vue-datatable-tbody-tr:hover{background-color:rgba(20,103,224,.2)}.contact-table[data-v-4dda240a] tr td{vertical-align:middle}", ""]);
// Exports
module.exports = exports;
